import states from './states';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
export default {
  states: states,
  getters: getters,
  mutations: mutations,
  actions: actions
};
